import NotificationManager, { ToastPosition } from '@chicksgroup/notifications';

const notifications = new NotificationManager({
    toast: {
        maxAmount: 1,
        timeout: 3000,
        preventDuplicates: true,
        separation: 10,
        yMargin: 60,
        xMargin: 30,
        position: ToastPosition.TopRight,
        delayDismissOnHover: true
    },
    breakpoint: 992,
    transformToasts: true,
    snackbar: {
        timeout: 3000
    }
});

export default notifications;
